import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  return (
    <>
      <Helmet>
        <title>Page non trouvée - Excellence Informatique</title>
        <meta name="description" content="La page que vous recherchez n'existe pas. Retournez à l'accueil d'Excellence Informatique pour découvrir nos services de dépannage informatique." />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      
      <div className="not-found-page">
        <div className="container">
          <div className="not-found-content">
            <div className="error-code">404</div>
            <h1>Page non trouvée</h1>
            <p className="error-message">
              Désolé, la page que vous recherchez n'existe pas ou a été déplacée.
            </p>
            <p className="error-description">
              Il est possible que l'URL soit incorrecte ou que la page ait été supprimée. 
              Retournez à notre page d'accueil pour découvrir nos services de dépannage informatique.
            </p>
            
            <div className="error-actions">
              <Link to="/" className="btn-primary">
                🏠 Retour à l'accueil
              </Link>
              <Link to="/accueil/domicile/" className="btn-secondary">
                🔧 Nos services
              </Link>
            </div>
            
            <div className="help-section">
              <h3>Besoin d'aide ?</h3>
              <p>Si vous pensez qu'il s'agit d'une erreur, n'hésitez pas à nous contacter :</p>
              <div className="contact-info">
                <p>📞 <Link to="/contact">Contactez-nous</Link></p>
                <p>📧 <Link to="/contact">Contactez-nous</Link></p>
              </div>
            </div>
            
            <div className="suggested-links">
              <h3>Pages populaires</h3>
              <ul>
                <li><Link to="/reparation/informatique/">Réparation Informatique</Link></li>
                <li><Link to="/reparation/pc/">Réparation PC</Link></li>
                <li><Link to="/accueil/domicile/loire-atlantique/">Dépannage Loire-Atlantique</Link></li>
                <li><Link to="/accueil/domicile/ordinateur/forfaits/windows/">Forfaits Windows</Link></li>
                <li><Link to="/recuperation-de-donnees/">Récupération de Données</Link></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;
